import { cn } from "@lib/cn"
import type { InputProps } from "@site-types/sendMail"
import { FieldTooltip } from "../FieldTooltip"
import { extractErrorMessage } from "../fieldUtils"

export const Input = ({
  inputLabel,
  toolTip,
  inputProps,
  errorMessage,
  register,
  errors,
  rules,
}: InputProps) => {
  const name = inputProps.name
  const id = inputProps.id || name
  const error = errors?.[name]
  const errorMsg = extractErrorMessage(errors, name, errorMessage)

  return (
    <div className="mb-8 flex flex-col">
      <label
        className="py-4"
        htmlFor={id}
      >
        {inputLabel}
      </label>

      <div className="relative inline-block w-full">
        <FieldTooltip
          message={errorMsg}
          open={!!error && toolTip}
        >
          <input
            {...inputProps}
            id={id}
            {...(register ? register(name, rules) : {})}
            className={cn("w-full", error && "outline-2 outline-[var(--pink)]", inputProps.className)}
          />
        </FieldTooltip>
      </div>
    </div>
  )
}
